var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileCloseFilters = function SvgMobileCloseFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mobile_close_filters_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".mobile_close_filters_svg__st0{fill:none;stroke:#000;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mobile_close_filters_svg__st0",
    d: "m20 20 8 8M28 20l-8 8"
  })));
};
export default SvgMobileCloseFilters;